export enum BetterUptimeStatus {
	Up = "Up",
	Down = "Down",
	Paused = "Paused",
	Pending = "Pending",
	Maintenance = "Maintenance",
	Validating = "Validating",
	Unknown = "Unknown"
}